

<div class="stripe-form">
  <!-- Display a payment form -->
  <form id="payment-form" style="padding: 10px; margin: auto;">
    <div class="mb-15 not-refresh-msg" translate>
      lbl_do_not_refresh_page_v1
      <span translate>lbl_do_not_refresh_page_v2</span>
    </div>
    <div id="payment-element">
      <!--Stripe.js injects the Payment Element-->
    </div>
    <button id="submit">
      <div class="spinner hidden" id="spinner"></div>
      <span id="button-text">Pay ${{ totalAmount }}</span>
    </button>
    <div style="text-align: center;" class="mt-25 error-msg-wrapper">
      <span class="payment-failed" *ngIf="paymentFailed">
        {{errorMessage}}
      </span>
    </div>
    
  </form>
</div>
<p-toast position="top-right"></p-toast>
